import React, { Component } from 'react';
import { GoWorkflow, GoPlay } from 'react-icons/go';
import { VscDebugLineByLine } from 'react-icons/vsc';
import EditorShell from '../editor/index.js';
import DebuggerShell from '../debugger/index.js';
import PlaygroundShell from '../playground/index.js';

export default class WorkflowsShell extends Component {
  // This shell switches between its own tabs (workflow/debugger/playground) off `match`, rather
  // than relying on the Blob page to wrap it in a single "default" pane -- see resolveShell() in
  // pages/Blob/index.js.
  static rendersOwnVisibility = true;

  static getTabs() {
    return [
      { key: "workflow",   title: "Workflow",   icon: GoWorkflow,            isDefault: true },
      { key: "debugger",   title: "Debugger",   icon: VscDebugLineByLine },
      { key: "playground", title: "Playground", icon: GoPlay },
    ];
  }

  render() {
    const section = this.props.match.params.section || "workflow";
    // The blob header collapse state is owned by the Blob page (which already
    // subscribes to Preferences and re-renders on change) and drilled in.
    const headerCollapsed = this.props.headerCollapsed;
    // `unsavedWork` is the Blob page's registry, asked before a revision switch remounts all three
    // of these. Only the editor and the playground get it: they are the only two components in the
    // whole tree with a `modified` flag, so the debugger has nothing to report.
    return (
      <>
        <div className={( "workflow" === section ) ? "" : "hidden"}>
          <EditorShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            shown={"workflow" === section}
            headerCollapsed={headerCollapsed}
            unsavedWork={this.props.unsavedWork}
          />
        </div>
        <div className={( "debugger" === section ) ? "" : "hidden"}>
          <DebuggerShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            shown={"debugger" === section}
          />
        </div>
        <div className={( "playground" === section ) ? "" : "hidden"}>
          <PlaygroundShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            shown={"playground" === section}
            headerCollapsed={headerCollapsed}
            unsavedWork={this.props.unsavedWork}
          />
        </div>
      </>
    );
  }
}
